(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[328],{

/***/ 3328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99982);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(79429);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(42227);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87344);
/* harmony import */ var highcharts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78840);
/* harmony import */ var highcharts__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(highcharts__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var highcharts_react_official__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75708);
/* harmony import */ var highcharts_react_official__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(highcharts_react_official__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_last__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73061);
/* harmony import */ var lodash_last__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_last__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82492);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71637);
/* harmony import */ var _format__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12597);
/* harmony import */ var _utils_use_active_breakpoint__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95251);
/* harmony import */ var _EquilibriumGraph_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(74249);
/* harmony import */ var _EquilibriumGraph_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_EquilibriumGraph_module_scss__WEBPACK_IMPORTED_MODULE_13__);











const SUPPLY_MIN = 0;
const SUPPLY_MAX = 140e6;
const baseOptions = {
    accessibility: {
        enabled: false
    },
    chart: {
        animation: false,
        backgroundColor: "transparent",
        showAxes: false
    },
    title: undefined,
    xAxis: {
        type: "datetime",
        tickInterval: 365.25 * 24 * 3600 * 1000,
        lineWidth: 0,
        labels: {
            enabled: false
        },
        tickWidth: 0
    },
    yAxis: {
        min: SUPPLY_MIN,
        max: SUPPLY_MAX,
        tickInterval: 20e6,
        title: {
            text: undefined
        },
        labels: {
            enabled: false
        },
        gridLineWidth: 0,
        plotLines: [
            {
                id: "equilibrium",
                color: _colors__WEBPACK_IMPORTED_MODULE_6__/* ["default"].slateus200 */ .Z.slateus200,
                label: {
                    align: "right",
                    text: "EQUILIBRIUM",
                    style: {
                        color: _colors__WEBPACK_IMPORTED_MODULE_6__/* ["default"].slateus200 */ .Z.slateus200
                    },
                    y: 5,
                    x: 20
                },
                width: 2,
                zIndex: 10
            },
            {
                id: "staking",
                color: _colors__WEBPACK_IMPORTED_MODULE_6__/* ["default"].slateus200 */ .Z.slateus200,
                label: {
                    align: "right",
                    text: "STAKING",
                    style: {
                        color: _colors__WEBPACK_IMPORTED_MODULE_6__/* ["default"].slateus200 */ .Z.slateus200
                    },
                    y: 18,
                    x: 1
                },
                width: 2,
                zIndex: 10
            }
        ]
    },
    legend: {
        enabled: false
    },
    tooltip: {
        backgroundColor: "transparent",
        xDateFormat: "%Y-%m-%d",
        useHTML: true,
        borderWidth: 0,
        shadow: false
    },
    credits: {
        enabled: false
    },
    plotOptions: {
        series: {
            color: {
                linearGradient: {
                    x1: 0,
                    y1: 0,
                    x2: 1,
                    y2: 0
                },
                stops: [
                    [
                        0,
                        "#1FD0E1"
                    ],
                    [
                        1,
                        "#6758F3"
                    ]
                ]
            },
            shadow: {
                color: "rgba(75, 144, 219, 0.2)",
                width: 15
            },
            marker: {
                lineColor: "white",
                fillColor: "#4B90DB",
                radius: 5,
                symbol: "circle"
            }
        }
    }
};
const EquilibriumGraph = (param)=>{
    let { staking , supplyEquilibrium , supplyEquilibriumMap , supplyEquilibriumSeries  } = param;
    const isRendering = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(true);
    const { lg , md , xl , xl2  } = (0,_utils_use_active_breakpoint__WEBPACK_IMPORTED_MODULE_8__/* .useActiveBreakpoint */ .P)();
    const width = xl2 ? 650 : xl ? 530 : lg ? 400 : md ? 570 : 280;
    const height = lg ? 320 : 200;
    const [options, setOptions] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(()=>{
        var ref, ref1;
        return lodash_merge__WEBPACK_IMPORTED_MODULE_4___default()({}, baseOptions, {
            chart: {
                events: {
                    render: function() {
                        isRendering.current = false;
                    }
                }
            },
            series: [
                {
                    id: "supply-series",
                    type: "spline",
                    data: [
                        ...supplyEquilibriumSeries,
                        {
                            id: "equilibrium-final-point",
                            x: (ref = lodash_last__WEBPACK_IMPORTED_MODULE_3___default()(supplyEquilibriumSeries)) === null || ref === void 0 ? void 0 : ref[0],
                            y: (ref1 = lodash_last__WEBPACK_IMPORTED_MODULE_3___default()(supplyEquilibriumSeries)) === null || ref1 === void 0 ? void 0 : ref1[1],
                            marker: {
                                symbol: "url(/dot_supply_graph.svg)",
                                enabled: true
                            }
                        }
                    ]
                }
            ]
        });
    });
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        const nextOptions = {
            chart: {
                width,
                height
            },
            xAxis: {
                minPadding: 0.03
            }
        };
        setOptions((currentOptions)=>lodash_merge__WEBPACK_IMPORTED_MODULE_4___default()({}, currentOptions, nextOptions));
    }, [
        height,
        md,
        staking,
        supplyEquilibrium,
        width
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        var ref, ref1;
        const lastPoint = lodash_last__WEBPACK_IMPORTED_MODULE_3___default()(supplyEquilibriumSeries);
        if (lastPoint === undefined) {
            return;
        }
        const maxX = xl2 ? date_fns__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z(date_fns__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z(date_fns__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z(lastPoint[0]), 80)) : xl ? date_fns__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z(date_fns__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z(date_fns__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z(lastPoint[0]), 100)) : lg ? date_fns__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z(date_fns__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z(date_fns__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z(lastPoint[0]), 140)) : md ? date_fns__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z(date_fns__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z(date_fns__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z(lastPoint[0]), 90)) : date_fns__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z(date_fns__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z(date_fns__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z(lastPoint[0]), 50));
        const nextOptions = {
            chart: {
                events: {
                    redraw: function() {
                        const yAxis0 = this.yAxis[0];
                        yAxis0.plotLinesAndBands.forEach(function(lineOrBand) {
                            const svg = lineOrBand.svgElem.element;
                            const d = svg.getAttribute("d");
                            if (d === null) {
                                return;
                            }
                            const dArr = d.split(" ");
                            const widthReductionLeft = xl2 ? 500 : xl ? 380 : lg ? 250 : md ? 420 : 230;
                            const widthReductionRight = md ? 90 : 15;
                            const newStartX = Number(dArr[1]) + widthReductionLeft;
                            const newStopX = Number(dArr[4]) - widthReductionRight;
                            dArr[1] = String(newStartX);
                            dArr[4] = String(newStopX);
                            svg.setAttribute("d", dArr.join(" "));
                        });
                    }
                }
            },
            series: [
                {
                    id: "supply-series",
                    type: "spline",
                    // fillColor: {
                    //   // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    //   linearGradient: [
                    //     0,
                    //     0,
                    //     0,
                    //     lg ? 280 : md ? 180 : 170,
                    //   ] as unknown as Highcharts.LinearGradientColorObject,
                    //   stops: [
                    //     [0, "#5487F420"],
                    //     [1, "#5487F400"],
                    //   ],
                    // },
                    data: [
                        ...supplyEquilibriumSeries,
                        {
                            x: (ref = lodash_last__WEBPACK_IMPORTED_MODULE_3___default()(supplyEquilibriumSeries)) === null || ref === void 0 ? void 0 : ref[0],
                            y: (ref1 = lodash_last__WEBPACK_IMPORTED_MODULE_3___default()(supplyEquilibriumSeries)) === null || ref1 === void 0 ? void 0 : ref1[1],
                            marker: {
                                symbol: "url(/dot_supply_graph.svg)",
                                enabled: true
                            }
                        }
                    ]
                }
            ],
            xAxis: {
                max: maxX
            },
            yAxis: {
                max: Math.min(Math.max(SUPPLY_MAX, supplyEquilibrium), 600e6),
                plotLines: [
                    {
                        id: "equilibrium",
                        value: supplyEquilibrium,
                        label: {
                            x: 10,
                            text: md ? "EQUILIBRIUM" : "(A)"
                        }
                    },
                    {
                        id: "staking",
                        value: staking,
                        label: {
                            x: md ? -19 : 10,
                            y: 4,
                            text: md ? "STAKING" : "(B)"
                        }
                    }
                ]
            },
            tooltip: {
                formatter: function() {
                    const x = typeof this.x === "number" ? this.x : undefined;
                    if (x === undefined) {
                        return;
                    }
                    const total = supplyEquilibriumMap[x];
                    if (total === undefined) {
                        return;
                    }
                    const dt = date_fns__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z(x);
                    const formattedDate = date_fns__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z(dt, "LLL y");
                    return '\n            <div class="font-roboto font-light bg-slateus-700 p-4 rounded-lg border-2 border-slateus-200">\n              <div class="text-slateus-200">\n                '.concat(formattedDate, '\n              </div>\n              <div class="text-white">\n                ').concat(_format__WEBPACK_IMPORTED_MODULE_7__/* .formatOneDecimal */ .F9(total / 1e6), 'M <span class="text-slateus-200">ETH</span>\n              </div>\n            </div>\n          ');
                }
            }
        };
        if (!isRendering.current) {
            isRendering.current = true;
            setOptions((currentOptions)=>lodash_merge__WEBPACK_IMPORTED_MODULE_4___default()({}, currentOptions, nextOptions));
        }
    }, [
        lg,
        md,
        staking,
        supplyEquilibrium,
        supplyEquilibriumMap,
        supplyEquilibriumSeries,
        xl,
        xl2
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex select-none justify-center ".concat((_EquilibriumGraph_module_scss__WEBPACK_IMPORTED_MODULE_13___default().equilibriumChart)),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((highcharts_react_official__WEBPACK_IMPORTED_MODULE_2___default()), {
            highcharts: (highcharts__WEBPACK_IMPORTED_MODULE_1___default()),
            options: options
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (EquilibriumGraph);


/***/ }),

/***/ 74249:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"equilibriumChart":"EquilibriumGraph_equilibriumChart__By7z9","supplyGraph":"EquilibriumGraph_supplyGraph__Z7nzn"};

/***/ })

}]);